// extracted by mini-css-extract-plugin
export default {"wrapper":"promo_wrapper__LAz0x","promoList":"promo_promoList__9oLOA"};